module.exports = __webpack_public_path__ + "static/media/refil-bliss.2dd66ccd.webp";